export const SHOULD_EXPAND_CATEGORIES = false;
export const POINTS_LABEL_ID = 'crowns';
export const CART_POINTS_LABEL_ID = 'cartLoyaltyPointsTitle';
